import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function whatsappTemplates() {
    return {
        index,
        get,
        create,
        remove,
        update
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`twilio-template-company/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`twilio-template-company/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('twilio-template-company/create', data);
    }

    function update(data) {
        return axiosInstance.patch('twilio-template-company/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`twilio-template-company/delete`, {
            data: id
        });
    }
}
